<template>
  <div id="page">
    <div class="banner-wrap">
      <section class="banners">
        <div class="title-wrap">
          <h4>加入大吕 娱乐未来</h4>
          <p>一起与我们展望未来，创造无限可能</p>
        </div>
        <div class="ren-wrap">
          <img src="https://jobs.chinanola.com/static/img/about/ren.gif" alt="" />
        </div>
      </section>
    </div>
    <div class="container">
      <section class="h1-wrap">
        <h4>
          <img
            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/MCN.png"
            alt=""
          />
          <p>MCN（Multi-Channel Network）</p>
        </h4>
        <div class="text-content">
          <p>
            大吕网络于2020年孵化游戏MCN机构巨芯互娱品牌，是一个拥有自孵化游戏达人矩阵及签约优质游戏达人的游戏MCN机构。目前，巨芯互娱MCN是抖音第二的游戏MCN，拥有强大的流量矩阵和品牌宣发能力。同时，大吕网络作为NBA中国全平台的官方运营机构，从账号孵化，成长助力，商业变现，品牌传播、资本对接及达人法务咨询，拥有完整的成长体系，赋能达人在全平台的资源导入和商业化变现。
          </p>
        </div>
        <div class="middle-content">
          <div class="div-group" id="eq">
            <div class="img-wrap">
              <img
                src="https://jobs.chinanola.com/static/img/flow/digitalcontent/11.png"
                alt=""
              />
            </div>
            <div class="content-div">
              <h2 class="title flex-end">游戏MCN</h2>
              <div class="title-desc flex-end">GAME MCN</div>
              <router-link to="/kols" class="href-wrap flex-end">
                <span><span>探索</span><span>&gt;</span> </span>
              </router-link >
            </div>
          </div>
          <div class="div-group" id="eq2">
            <div class="content-div">
              <h2 class="title flex">篮球MCN</h2>
              <div class="title-desc flex size20">篮球机构</div>
              <router-link to="/nba" class="href-wrap flex">
                <span><span>探索</span><span>&gt;</span> </span>
              </router-link >
            </div>
            <div class="img-wrap">
              <img
                src="https://jobs.chinanola.com/static/img/flow/digitalcontent/22.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>

      <section class="h2-wrap">
        <h4>
          <img
            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/yxdr.png"
            alt=""
          />
          <p>Excellent talent</p>
        </h4>
        <div class="content-wrap">
          <div class="flipbook-viewport">
            <div class="flipbook-container">
              <div class="flipbook">
                <div class="bookitem">
                  <div class="wrap">
                    <div class="desc-wrap">
                      <div class="desc-content">
                        <h3>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_1.png"
                            class="flipbook_h3"
                            alt=""
                          />
                          <span>白菜君</span>
                        </h3>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>粉丝数：184w+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>播放数：5200w+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>点赞数：1700w+</span>
                        </p>
                      </div>
                    </div>
                    <div class="img-wrap">
                      <img
                        src="https://jobs.chinanola.com/static/img/flow/digitalcontent/talent_1.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="bookitem">
                  <div class="wrap">
                    <div class="desc-wrap">
                      <div class="desc-content">
                        <h3>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_1.png"
                            class="flipbook_h3"
                            alt=""
                          />
                          <span>陈尼玛评测</span>
                        </h3>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>粉丝数：523w+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>播放数：17亿+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>点赞数：6700w+</span>
                        </p>
                      </div>
                    </div>
                    <div class="img-wrap">
                      <img
                        src="https://jobs.chinanola.com/static/img/flow/digitalcontent/talent_2.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
                <div class="bookitem">
                  <div class="wrap">
                    <div class="desc-wrap">
                      <div class="desc-content">
                        <h3>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_1.png"
                            class="flipbook_h3"
                            alt=""
                          />
                          <span>小吴叔</span>
                        </h3>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>粉丝数：220w+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>播放数：6亿+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>点赞数：1800w+</span>
                        </p>
                      </div>
                    </div>
                    <div class="img-wrap">
                      <img
                        src="https://jobs.chinanola.com/static/img/flow/digitalcontent/talent_3.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>

                <div class="bookitem">
                  <div class="wrap">
                    <div class="desc-wrap">
                      <div class="desc-content">
                        <h3>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_1.png"
                            class="flipbook_h3"
                            alt=""
                          />
                          <span>凉凉小师姐</span>
                        </h3>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>粉丝数：88w+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>播放数：5亿+</span>
                        </p>
                        <p>
                          <img
                            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_11.png"
                            class="flipbook_icon"
                            alt=""
                          />
                          <span>点赞数：2300w+</span>
                        </p>
                      </div>
                    </div>
                    <div class="img-wrap">
                      <img
                        src="https://jobs.chinanola.com/static/img/flow/digitalcontent/talent_4.png"
                        alt=""
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section class="h3-wrap">
        <h4>
          <img
            src="https://jobs.chinanola.com/static/img/flow/digitalcontent/yxal.png"
            alt=""
          />
          <p>Excellent cases</p>
        </h4>
        <div class="content-wrap">
          <div class="content">
            <div class="item-wrap" @mouseover="videoshow = 1">
              <img
                src="https://jobs.chinanola.com/static/img/flow/digitalcontent/video_image_1.png"
                alt=""
              />
              <div v-if="videoshow == 1">
                <div class="item-mask"></div>
                <img
                  src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_44.png"
                  alt=""
                  class="video_icon"
                  @click="showDiglog = true"
                />
              </div>
            </div>
            <div class="item-wrap" @mouseenter="videoshow = 2">
              <img
                src="https://jobs.chinanola.com/static/img/flow/digitalcontent/video_image_2.png"
                alt=""
              />
              <div v-if="videoshow == 2">
                <div class="item-mask"></div>
                <img
                  src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_44.png"
                  alt=""
                  class="video_icon"
                  @click="showDiglog = true"
                />
              </div>
            </div>
            <div class="item-wrap" @mouseover="videoshow = 3">
              <img
                src="https://jobs.chinanola.com/static/img/flow/digitalcontent/video_image_3.png"
                alt=""
              />
              <div v-if="videoshow == 3">
                <div class="item-mask"></div>
                <img
                  src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_44.png"
                  alt=""
                  class="video_icon"
                  @click="showDiglog = true"
                />
              </div>
            </div>
            <div class="item-wrap" @mouseover="videoshow = 4">
              <img
                src="https://jobs.chinanola.com/static/img/flow/digitalcontent/video_image_4.png"
                alt=""
              />
              <div v-if="videoshow == 4">
                <div class="item-mask"></div>
                <img
                  src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_44.png"
                  alt=""
                  class="video_icon"
                  @click="showDiglog = true"
                />
              </div>
            </div>
            <div class="item-wrap" @mouseover="videoshow = 5">
              <img
                src="https://jobs.chinanola.com/static/img/flow/digitalcontent/video_image_5.png"
                alt=""
              />
              <div v-if="videoshow == 5">
                <div class="item-mask"></div>
                <img
                  src="https://jobs.chinanola.com/static/img/flow/digitalcontent/icon_44.png"
                  alt=""
                  class="video_icon"
                  @click="showDiglog = true"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
      <div :class="showDiglog ? 'block' : ''" class="displaynone">
        <div class="diglog-wrap" style="min-width: 300px">
          <div class="d-content">
            <video
              width="350"
              v-if="videoshow == 1"
              preload="auto"
              controls="controls"
              playsinline=""
              autoplay="autoplay"
              muted="muted"
              src="https://jobs.chinanola.com/static/img/flow/digitalcontent/demo_video_3.mp4"
              tabindex="-1"
              class="video"
            ></video>
            <video
              width="350"
              v-if="videoshow == 2"
              preload="auto"
              controls="controls"
              playsinline=""
              autoplay="autoplay"
              muted="muted"
              src="https://jobs.chinanola.com/static/img/flow/digitalcontent/demo_video_5.mp4"
              tabindex="-1"
              class="video"
            ></video>
            <video
              width="350"
              v-if="videoshow == 3"
              preload="auto"
              controls="controls"
              playsinline=""
              autoplay="autoplay"
              muted="muted"
              src="https://jobs.chinanola.com/static/img/flow/digitalcontent/demo_video_2.mp4"
              tabindex="-1"
              class="video"
            ></video>
            <video
              width="350"
              v-if="videoshow == 4"
              preload="auto"
              controls="controls"
              playsinline=""
              autoplay="autoplay"
              muted="muted"
              src="https://jobs.chinanola.com/static/img/flow/digitalcontent/demo_video_1.mp4"
              tabindex="-1"
              class="video"
            ></video>
            <video
              width="350"
              v-if="videoshow == 5"
              preload="auto"
              controls="controls"
              playsinline=""
              autoplay="autoplay"
              muted="muted"
              src="https://jobs.chinanola.com/static/img/flow/digitalcontent/demo_video_4.mp4"
              tabindex="-1"
              class="video"
            ></video>
          </div>
        </div>
        <div
          class="mask"
          @click="
            showDiglog = false;
            videoshow = 0;
          "
        ></div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  mame:'digitalcontent',
  data() {
    return {
      videoshow: 0,
      showTop: false,
      showSt: false,
      showDiglog: false,
    };
  },
  created: function () {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "../assets/css/global";
@import "../assets/css/function";
@import "../assets/css/index";



// 内容容器
.container {
  padding: 0 15px;
  section {
    > h4 {
      letter-spacing: 4px;
      color: #535353;
      font-weight: 700;
      line-height: 1em;
      text-align: center;
      margin-bottom: 10px;
    }
    > p {
      letter-spacing: 1px;
      line-height: 1.6em;
      color: #535353;
      text-align: center;
    }
  }
}

.banners {
  position: relative;
  width: 100%;
  height: 200px;
  margin: 4rem 0 -2rem 0;
  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .ren-wrap {
    position: absolute;
    top: 100px;
    right: 20%;
    width: 14%;
  }
}
#page {
  background: url(../assets/img/flow/digitalcontent/bg.png);
  background-size: 100% 100%;
}
.title-wrap {
  position: absolute;
  left: 12%;
  top: 20%;
  h4 {
    font-size: 1.6rem;
    margin-bottom: 20px;
    color: #fff;
    letter-spacing: 2px;
  }
  p {
    font-size: 1rem;
    color: #fff;
    letter-spacing: 2px;
  }
}
.h1-wrap {
  > h4 {
    width: 50%;
    margin: 0 auto;
    p {
      margin-top: 5%;
      color: #999;
      letter-spacing: 1px;
    }
  }
  .text-content {
    p {
      letter-spacing: 1px;
      font-family: arial, helvetica, sans-serif;
      font-size: .8rem;
      line-height: 2em;
      text-align: center;
    }
  }
  .middle-content {
    margin-top: 10%;
    .div-group {
      display: flex;
      justify-content: center;
      .img-wrap {
        max-width: 60%;
        position: relative;
      }
      .content-div {
        flex: 1;
        text-align: right;
        display: flex;
        flex-direction: column;
        justify-content: center;
        .title {
          font-size: 2rem;
          letter-spacing: 1px;
        }
        .title-desc {
          font-size: 1.2rem;
          font-weight: bolder;
          color: #999;
          margin: .3rem 0 .5rem 0;
        }
        .flex-end {
          display: flex;
          justify-content: flex-end;
        }
        .flex {
          display: flex;
        }
        .size20 {
          font-size: 1rem;
        }
        .href-wrap {
          > span {
            display: flex;
            padding: 0.1rem 1rem;
            background-color: #ff36ac;
            border-radius: 20px;
            color: #fff;
            font-weight: bolder;
            > span {
              &:first-child {
                padding-right: 2rem;
              }
              &:last-child {
                padding-top: 2px;
              }
            }
          }
        }
      }
    }
  }
}
.h2-wrap {
  position: relative;
  > h4 {
    width: 50%;
    margin: 0 auto;
    margin-bottom: 50px !important;
    p {
      margin-top: 5%;
      color: #999;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  }

  .bookitem {
    .wrap {
      display: flex;
      background: url("https://jobs.chinanola.com/static/img/flow/digitalcontent/drbg.png");
      background-size: 100% 100%;
      background-repeat: no-repeat;
      .desc-wrap {
        flex: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        .desc-content {
          width: 80%;
          margin: 0 auto;
          h3 {
            display: flex;
            margin-bottom: 10%;
            span {
              font-size: 1rem;
                  line-height: 1.8rem;
            }
            img {
              width: 2rem;
              height: 2rem;
            }
          }
        }
        p {
          display: flex;
          padding-left: .5rem;
          color: #535353;
          margin: 10px 0;
        }
        .flipbook_icon {
          width: 1rem;
          height: 1rem;
          margin-right: .2rem;
        }
      }
      .img-wrap {
        flex: 1;
        max-width: 50%;
        padding: 1.5% 2% 2% 0;
        img {
          border-radius: 0 15% 15% 0;
          user-select: none;
        }
      }
    }
  }
}
.h3-wrap {
  padding-top: 6%;
  padding-bottom: 6%;
  position: relative;
  > h4 {
    width: 50%;
    margin: 0 auto;
    margin-bottom: 50px !important;
    p {
      margin-top: 5%;
      color: #999;
      letter-spacing: 1px;
      text-transform: uppercase;
    }
  }
  .content-wrap {
    .content {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item-wrap {
        width: 48%;
        height: 326px;
        overflow: hidden;
        border-radius: 20px;
        position: relative;
        margin-bottom: 2%;
        &:nth-child(even) {
          margin-right: 1%;
        }
        .item-mask {
          background-color: #000;
          opacity: 0.5;
          position: absolute;
          z-index: 6;
          left: 0;
          top: 0;
          right: 0;
          bottom: 0;
        }
        .video_icon {
          width: 50px;
          height: 50px;
          position: absolute;
          top: 40%;
          left: 38%;
          z-index: 7;
          cursor: pointer;
        }
        > img {
          border-radius: 20px;
          height: 100%;
        }
      }
    }
  }
}
.displaynone {
  display: none;
}
.block {
  display: block;
}
.mask {
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 100;
  position: fixed;
}
.diglog-wrap {
  position: fixed;

  top: 15%;
  left: 50%;
  border-radius: 8px;
  overflow: hidden;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  z-index: 110;
  .d-content {
    position: relative;
    min-height: 100px;
    background-color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/page/digitalcontent.vue